import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_ROLES_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ROLES_KEY;
const supabaseRoles = createClient(supabaseUrl, supabaseKey);

export default supabaseRoles;